module.exports = __webpack_public_path__ + "img/yingyong.4af04a18.svg";